import { render, staticRenderFns } from "./ServiceQuotation.vue?vue&type=template&id=6e71db97&"
import script from "./ServiceQuotation.vue?vue&type=script&lang=js&"
export * from "./ServiceQuotation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports